import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';

const CO_APPLICANT_STATES = ['KYC_CO_APPLICANT', 'CO_SUBMIT'];

export const getStateHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/state', async () => {
        const session = MockServiceWorker.getMockedSession();
        const isCoApplicantState = session.state ? CO_APPLICANT_STATES.includes(session.state) : false;
        return HttpResponse.json({
            state: session.state,
            applicantRole: isCoApplicantState || !MockServiceWorker.isMainApplicant() ? 'CO' : 'MAIN',
        });
    }),
];
